import React from 'react';
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { Store } from 'redux';
import type PlanDependenciesReportType from '@jira/spa-apps__advanced-roadmaps-plan-dependencies-report/src/PlanDependenciesReport.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

/**
 * Plan DependenciesReport page
 */

export const LazyPlanDependenciesReport: LazyComponent<
	({ store }: { store: Store }) => React.JSX.Element
> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanDependenciesReportType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-dependencies-report", jiraSpaEntry: "async-plan-dependencies-report" */ '@jira/spa-apps__advanced-roadmaps-plan-dependencies-report/src/PlanDependenciesReport.tsx'
				),
			),
		{ ssr: false },
	);

const AsyncPlanDependenciesReport = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanDependenciesReport} pageId="plan-dependencies-report" shouldShowSpinner />
);

export default AsyncPlanDependenciesReport;
